import styled, { css } from 'styled-components'
import { FaHotel } from 'react-icons/fa'

export const Container = styled.div`
  &&& {
    display: flex;
    align-items: center;

    &.align-flex-start {
      align-items: flex-start;
    }
    width: 100%;
    height: 100%;
    gap: 5px;
    min-height: 60px;
    padding: 0px 20px;

    .container-icon {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &.align-flex-start {
        align-items: flex-start;
      }
    }

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      max-width: 100%;
      overflow: hidden;

      strong {
        font-weight: 900;
      }

      &.isFeatured {
        font-weight: 700;
        font-size: 16px;
      }
    }
  }
`
export const Info = styled.div`
  &&& {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    width: 100%;
  }
`

export const Name = styled.span`
  &&& {
    margin: 0;
    padding: 0;
  }
`

export const LabelBold = styled.small`
  &&& {
    margin: 5px 0 0;
    font-weight: bold;
  }
`

export const Address = styled.small`
  &&& {
    margin: 5px 0 0;
  }
`

const Icon = css`
  margin: 0 10px 0 0;
  height: 24px;
  min-height: 24px;
  min-width: 24px;
  padding: 0;
  width: 24px;
`

export const ContentIcon = styled.img`
  &&& {
    ${Icon}
  }
`

export const HotelIcon = styled(FaHotel)`
  &&& {
    ${Icon}
    font-size: 15px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    width: 18px;
  }
`
